import React, { useEffect } from 'react';
import { Input } from '@cokitchen/cokitchen-components';

import useNewShopContext from 'contexts/create-shop.context';
import AmountInput from 'components/amount-input';

const CreateShopFees = () => {
  const { createShopForm, setCreateShopForm, setDisabled } = useNewShopContext();
  const handleChange = (
    field: keyof typeof createShopForm,
    value: string,
    allowDecimal = false
  ) => {
    let numericValue = value;

    numericValue = allowDecimal
      ? numericValue.replace(/[^0-9.]/g, '')
      : numericValue.replace(/[^0-9]/g, '');

    setCreateShopForm({
      ...createShopForm,
      [field]: numericValue === '' ? '' : Number(numericValue)
    });
  };
  useEffect(() => {
    const isDisabled =
      createShopForm?.platform_fee == null ||
      createShopForm?.platform_fee_cap == null ||
      createShopForm?.service_fee == null ||
      createShopForm?.service_fee_cap == null;

    setDisabled(isDisabled);
  }, [createShopForm]);

  return (
    <>
      <Input
        type='number'
        label='Platform Fee %'
        placeholder='Enter percentage'
        className='w-full mt-4'
        inputClass='px-[20px] py-[14px]'
        value={createShopForm?.platform_fee ?? ''}
        min={0}
        max={1}
        step={0.01}
        onChange={(e) => handleChange('platform_fee', e.target.value, true)}
      />

      <AmountInput
        type='text'
        label='Platform Fee Cap (₦)'
        placeholder='Enter cap amount'
        className='w-full mt-4'
        value={createShopForm?.platform_fee_cap === 0 ? '' : createShopForm?.platform_fee_cap}
        min={0}
        step={1}
        onChange={(e) => handleChange('platform_fee_cap', e, false)}
      />

      <Input
        type='number'
        label='Service Fee %'
        placeholder='Enter percentage'
        className='w-full mt-4'
        inputClass='px-[20px] py-[14px]'
        value={createShopForm?.service_fee ?? ''}
        min={0}
        max={1}
        step={0.01}
        onChange={(e) => handleChange('service_fee', e.target.value, true)}
      />

      <AmountInput
        type='text'
        label='Service Fee Cap (₦)'
        placeholder='Enter cap amount'
        className='w-full mt-4'
        value={createShopForm?.service_fee_cap === 0 ? '' : createShopForm?.service_fee_cap}
        min={0}
        step={1}
        onChange={(e) => handleChange('service_fee_cap', e, false)}
      />
    </>
  );
};

export default CreateShopFees;
